import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FavoritosService } from './../../services/favoritos.service';

@Component({
  selector: 'app-material-card',
  templateUrl: './material-card.component.html',
  styleUrls: ['./material-card.component.scss']
})
export class MaterialCardComponent implements OnInit {
  @Input() item;
  @Input() favList;
  @Input() isOutlet = false;
  @Output() addFavList: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeFavList: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _favoritos: FavoritosService) { }

  ngOnInit() {
  }

  addFav() {
    this._favoritos.addFav(this.item).subscribe();
  }

  removeFav() {
    this._favoritos.removeFav(this.item).subscribe();
  }

  getStyle(item) {
    let myStyles = {
      'background-color': 'transparent',
      'background-image': 'url(http://189.126.197.169/img/small/small_'+item.MATNR+'.jpg)',
      // 'background-image': 'url(//services.focustextil.com.br/img/small/small_'+item.MATNR+'.jpg)',
      'background-size': 'cover',
      'background-position': 'center'
    };
    if (item.Master && item.Master.RGB) {
      myStyles = {
        'background-color': 'rgb('+ item.Master.RGB.R +','+ item.Master.RGB.G +' ,'+ item.Master.RGB.B +' )',
        'background-image': 'url(http://189.126.197.169/img/small/small_'+item.MATNR+'.jpg)',
        // 'background-image': 'url(//services.focustextil.com.br/img/small/small_'+item.MATNR+'.jpg)',
        'background-size': 'cover',
        'background-position': 'center'
      };
    }
    return myStyles;
  }

}
